import { ReactNode, useState } from "react";
import { Box, Collapse, Flex, Heading, Icon } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";

type Props = {
  title: string;
  defaultExpanded?: boolean;
  // Ação exibida ao lado do título (ex.: botão de ação primária da seção),
  // sempre visível mesmo com a seção colapsada.
  headerAction?: ReactNode;
  // Notifica o pai a cada abre/fecha — usado para lazy-load do conteúdo/queries
  // da seção (ver PayrollCollectionsDetails). Opcional; o protótipo não usa.
  onToggle?: (expanded: boolean) => void;
  children: ReactNode;
};

export default function CollapsibleSection({
  title,
  defaultExpanded = true,
  headerAction,
  onToggle,
  children,
}: Props) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const toggle = () =>
    setExpanded((prev) => {
      const next = !prev;
      onToggle?.(next);
      return next;
    });

  return (
    <Box bg="gray.50" borderRadius="md" p={4}>
      <Flex alignItems="center" justifyContent="space-between" mb={3} gap={2}>
        <Heading as="h3" fontSize="lg" lineHeight="1" m={0}>
          {title}
        </Heading>

        <Flex alignItems="center" gap={2}>
          {headerAction}
          <Icon
            as={expanded ? ChevronUpIcon : ChevronDownIcon}
            boxSize={5}
            color="gray.500"
            cursor="pointer"
            onClick={toggle}
          />
        </Flex>
      </Flex>

      <Collapse in={expanded} animateOpacity>
        {children}
      </Collapse>
    </Box>
  );
}
